import { useRef } from "react";
import { Upload, FolderPlus, Trash2, ChevronRight, RefreshCw, Bot } from "lucide-react";

export default function DriveToolbar({ segs, selected, uploading, viewMode, agentOpen, onNavigate, onRefresh, onNewFolder, onDeleteSelected, onUpload, onViewChange, onToggleAgent }) {
  const fileInputRef = useRef(null);

  return (
    <div className="px-5 py-3 border-b border-border bg-white flex items-center gap-3 flex-shrink-0">
      <nav className="flex items-center gap-1 flex-1 min-w-0 text-xs">
        {segs.map((seg, i) => (
          <span key={seg.path} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground flex-shrink-0" />}
            <button
              onClick={() => onNavigate(seg.path)}
              className={`hover:text-[#A8A67A] transition-colors truncate max-w-[120px] ${
                i === segs.length - 1 ? "font-semibold text-foreground" : "text-muted-foreground"
              }`}
              data-testid={`breadcrumb-${seg.label}`}
            >
              {seg.label}
            </button>
          </span>
        ))}
      </nav>
      <div className="flex items-center gap-2 flex-shrink-0">
        {selected.size > 0 && (
          <button onClick={onDeleteSelected}
            className="flex items-center gap-1.5 text-xs text-red-600 border border-red-200 bg-red-50 px-3 py-1.5 hover:bg-red-100 transition-colors"
            data-testid="delete-selected-btn">
            <Trash2 className="w-3.5 h-3.5" /> Delete ({selected.size})
          </button>
        )}
        <button onClick={onRefresh} className="p-1.5 text-muted-foreground hover:text-foreground hover:bg-[#F5F4EE] transition-colors" title="Refresh">
          <RefreshCw className="w-3.5 h-3.5" />
        </button>
        <button onClick={onNewFolder}
          className="flex items-center gap-1.5 text-xs border border-border bg-white px-3 py-1.5 hover:bg-[#F5F4EE] transition-colors font-medium"
          data-testid="new-folder-btn">
          <FolderPlus className="w-3.5 h-3.5" /> New Folder
        </button>
        <button onClick={() => fileInputRef.current?.click()} disabled={uploading}
          className="flex items-center gap-1.5 text-xs bg-[#A8A67A] text-white px-3 py-1.5 hover:bg-[#8E8C64] transition-colors font-medium disabled:opacity-60"
          data-testid="upload-btn">
          <Upload className="w-3.5 h-3.5" /> {uploading ? "Uploading…" : "Upload Files"}
        </button>
        <input ref={fileInputRef} type="file" multiple className="hidden"
          onChange={(e) => { onUpload([...e.target.files]); e.target.value = ""; }} />
        <div className="flex border border-border">
          {["grid", "list"].map(v => (
            <button key={v} onClick={() => onViewChange(v)}
              className={`px-2.5 py-1.5 text-xs transition-colors ${viewMode === v ? "bg-[#A8A67A] text-white" : "bg-white text-muted-foreground hover:text-foreground"}`}
              data-testid={`view-${v}`}>
              {v === "grid" ? "⊞" : "☰"}
            </button>
          ))}
        </div>
        <button
          onClick={onToggleAgent}
          title="File Agent"
          className={`flex items-center gap-1.5 text-xs px-3 py-1.5 border transition-colors font-medium ${
            agentOpen
              ? "bg-[#A8A67A] text-white border-[#A8A67A]"
              : "border-border bg-white text-muted-foreground hover:text-[#A8A67A] hover:border-[#A8A67A]/40"
          }`}
          data-testid="toggle-agent-btn"
        >
          <Bot className="w-3.5 h-3.5" />
          Agent
        </button>
      </div>
    </div>
  );
}
